import { render, staticRenderFns } from "./NewSearch.vue?vue&type=template&id=4fe28cc6&scoped=true&"
import script from "./NewSearch.vue?vue&type=script&setup=true&lang=js&"
export * from "./NewSearch.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe28cc6",
  null
  
)

export default component.exports